<template>
  <div
    v-if="isShowPage"
    class="estate-price"
  >
    <nav-bar
      :title="lang.propertyListings"
      :show-type="'text'"
      :show-menu="false"
      class="price-nav-bar"
    />
    <div
      class="remark"
      @click="openPreview"
    >
      {{ lang.remark }}
    </div>
    <div
      v-if="image_show"
      class="close-button"
      @click="closePreview"
    />
    <van-image-preview
      v-model="image_show"
      :images="image_images"
      :show-index="false"
    />
    <div class="est-release">
      <!-- 放盘价格 -->
      <section
        v-if="JSON.stringify(normal) !== '{}'"
        class="normal"
      >
        <div class="flexbox">
          <div class="title">
            <img
              src="./../assets/standard.png"
              alt=""
              width="18px"
              height="20px"
            >
            <span>{{ lang.listingNormal }}</span>
          </div>
          <div class="price">
            <div class="landlord">
              <span>{{ lang.Landlord }}</span>
              <div>
                <del>HK${{ normal.price }}</del>
                <span> HK${{ normal.discountPrice }}</span>
              </div>
            </div>
            <div class="agency">
              <span>{{ lang.agency }}</span>
              <span>HK${{ normal_Agent.discountPrice }}</span>
            </div>
          </div>
        </div>
        <div class="inter">
          {{ lang.validitySale[0] }}{{ normal.effectiveDays }}{{ lang.validitySale[1] }}{{ lang.validityRent[0] }}{{ normal.rentEffectiveDays }}{{ lang.validityRent[1] }}
        </div>
      </section>
      <section
        v-if="JSON.stringify(Star) !== '[]'"
        class="gold"
      >
        <div class="flexbox">
          <div class="title">
            <img
              src="./../assets/star.png"
              alt=""
              width="18px"
              height="20px"
            >
            <span>{{ lang.Star }}</span>
          </div>
          <div class="price-Star">
            <h3>{{ lang.sale }} HK${{ Star[0].discountPrice }}</h3>
            <h3>{{ lang.rent }} HK${{ Star[1].discountPrice }}</h3>
          </div>
        </div>
        <div class="inter">
          {{ lang.StarSale[0] }}{{ Star[0].effectiveDays }}{{ lang.StarSale[1] }}{{ lang.StarRent[0] }}{{ Star[1].rentEffectiveDays }}{{ lang.StarRent[1] }}
        </div>
      </section>
      <!-- 联络说明 -->
      <div class="agent-phone">
        <p>
          {{ lang.agencytxt[0] }}<span @click="goUs">{{ lang.agencytxt[1] }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import pub from '../../common/public';
import '../../common/css/common.scss';
import navBar from '../components/navBar.vue';
import lang from './../../common/language/estatePrice';
const _conf = require('../../common/js/_conf');
export default {
  metaInfo: { title: lang.propertyListings },
  name: 'EstatePrice',
  components: {
    navBar
  },
  filters: {
    setPrice(value) {
      return Number(value).toFixed(2);
    }
  },
  data() {
    return {
      isShowPage: false,
      lang,
      normal: {},
      normal_Agent: {},
      Star: [],
      isPc: false,
      image_show: false,
      image_images: [],
      language: document.URL.indexOf('en-us') > -1 ? 'en-us' : document.URL.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk',
    };
  },
  mounted() {
    this.isPc = !(document.body.clientWidth <= 750 || /mobi|android|iphone|blackberry|ipod|iemobile/i.test(navigator.userAgent.toLocaleLowerCase()))
    if (this.isPc) {
      if (pub.getLang() === 'zh-cn') {
        location.href = `${pub.config.pcUrl}zh-cn/help/charge/`;
      } else if (pub.getLang() === 'en-us') {
        location.href = `${pub.config.pcUrl}en-us/help/charge/`;
      } else {
        location.href = `${pub.config.pcUrl}help/charge/`;
      }
    } else {
      this.isShowPage = true;
    }
    this.getDayPrice();
  },
  methods: {
    openPreview() {
      this.image_show = true
      this.image_images = this.language === 'en-us' ? [require('@/assets/remark_en.png')] : this.language === 'zh-cn' ?  [require('@/assets/remark_cn.png')] : [require('@/assets/remark.png')]
    },
    closePreview() {
      this.image_show = false
    },
    //获取动态数据
    getDayPrice() {
      this.axios.get(this.pub.getApi().SearchPropertyPriceSet).then(res => {
        const { data, status } = res;
        if (status == 200) {
          data.result.forEach(item => {
            if (item.itemName == 'Normal') {
              this.normal = item;
            }
            if (item.itemName == 'Normal_Agent') {
              this.normal_Agent = item;
            }
            if (item.itemName.startsWith('Star')) {
              this.Star.push(item);
            }
          });
        }
      });
    },
    // 跳转到联络我们
    goUs() {
      const base = _conf.env_type == 4 ? 'https://sim.house730.com' : _conf.env_type == 3 ? 'https://www.house730.com' : 'https://uat.house730.com.cn';
      if (document.URL.indexOf('en-us') > -1) {
        location.href = `${base}/en-us/help/contactus/`;
      } else if (document.URL.indexOf('zh-cn') > -1) {
        location.href = `${base}/zh-cn/help/contactus/`;
      } else {
        location.href = `${base}/help/contactus/`;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.estate-price {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  width: 100%;
  min-height: 100vh;
  background: #f5f6f7;
}
// .price-nav-bar {
//   margin-bottom: 16px;
// }
.remark {
  font-family: PingFangSC-SNaNpxibold;
  font-weight: 600;
  font-size: 14px;
  color: #106FC4;
  letter-spacing: 0;
  text-decoration: underline;
  padding: 16px;
  text-align: left;
}
.close-button {
  z-index: 9999;
  position: fixed;
  width: 38px;
  height: 38px;
  background: url(./../assets/close@2x.png) center/contain no-repeat;
  border-radius: 50%;
  top: 87%;
  left: 46%;
}
.van-image-preview__image {
  border-radius: 4px;
}
::v-deep .van-image-preview__image {
  height: 496px !important;
  width: 327px !important;
}
.est-release {
  padding: 0 16px;
  section {
    background: #ffffff;
    border: 1px solid #d8d8d8;
    margin-bottom: 15px;
    padding: 15px;
    box-sizing: border-box;
    .flexbox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eeeeee;
      padding-bottom: 9px;
      .title {
        display: flex;
        align-items: center;
        span {
          font-size: 20px;
          font-weight: 600;
          text-align: left;
          color: #333333;
          line-height: 28px;
          margin-left: 8px;
        }
      }
      .price-Star {
        // position: relative;
        // top: -10px;
        h3 {
          font-size: 17px;
          font-weight: 600;
          text-align: left;
          color: #333333;
          line-height: 24px;
        }
      }
      .price {
        display: flex;
        flex-direction: column;
        text-align: left;
        .landlord {
          display: flex;
          align-items: center;
          span {
            font-size: 17px;
            font-weight: 600;
            text-align: left;
            color: #333333;
            line-height: 24px;
            margin-right: 7px;
          }
          div {
            display: flex;
            flex-direction: column;
            del {
              font-size: 17px;
              font-weight: 600;
              text-align: left;
              color: #999999;
              line-height: 24px;
            }
            span {
              font-size: 17px;
              font-weight: 600;
              text-align: left;
              color: #333333;
              line-height: 24px;
            }
          }
        }
        .agency {
          span {
            font-size: 17px;
            font-weight: 600;
            text-align: left;
            color: #333333;
            line-height: 24px;
            margin-right: 7px;
          }
        }
      }
    }
    .inter {
      font-size: 14px;
      font-weight: 400;
      text-align: left;
      color: #999999;
      // line-height: 40px;
      line-height: 14px;
      box-sizing: border-box;
      padding-top: 10px;
    }
  }
  .gold {
    .flexbox {
      padding-bottom: 15px !important;
    }
  }
}
.agent-phone {
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  color: #999999;
  line-height: 17px;
  span {
    color: dodgerblue;
  }
}
</style>
